import { Box, Button, Typography } from '@mui/material'
import { type Model } from 'survey-core'
import { useState } from 'react'
import { Modal } from '../Modal'

interface Props {
  survey: Model
  saveSurvey?: (survey: Model, submit?: boolean) => Promise<void>
  styles?: {
    container?: Record<string, any>
  }
}

export function SurveyNavigationButtons ({ survey, saveSurvey, styles }: Props): JSX.Element {
  const [showSaveModal, setShowSaveModal] = useState(false)

  const pageHasErrors = (pageIndex: number): boolean => {
    const page = survey.pages[pageIndex]
    const allQuestions = page.getQuestions(true)
    return allQuestions.some(q => {
      const isActuallyRequired = q.isRequired && q.isVisible
      return isActuallyRequired && q.isEmpty()
    })
  }

  const hasAnyErrors = (): boolean => {
    return survey.pages.some(page => {
      return pageHasErrors(survey.pages.indexOf(page))
    })
  }

  const handleNext = async (): Promise<void> => {
    await saveSurvey?.(survey, false)
    survey.nextPage()
  }

  return (
    <>
      <Box sx={styles?.container}>
        {!survey.isFirstPage && (
          <Button
            variant="outlined"
            onClick={() => { survey.prevPage() }}
          >
            Previous
          </Button>
        )}
        {survey.isLastPage
          ? (
            <Button
              variant="contained"
              onClick={async () => {
                if (hasAnyErrors()) {
                  setShowSaveModal(true)
                } else {
                  survey.tryComplete()
                }
              }}
            >
              {hasAnyErrors() ? 'Save' : 'Submit'}
            </Button>
            )
          : (
            <Button
              variant="contained"
              onClick={() => { void handleNext() }}
            >
              Save and Continue
            </Button>
            )
        }
      </Box>
      {showSaveModal && (
        <Modal
          open={true}
          title="Saving, Not Submitting"
          onClose={() => {
            setShowSaveModal(false)
          }}
          onConfirm={() => {
            void saveSurvey?.(survey, false)
            setShowSaveModal(false)
          }}
          confirmButtonText="Continue"
          bodyContent={(
            <>
              <Typography variant="body1">Some required fields are missing. If you continue, your progress will be saved as a draft, but you will not be able to submit until all required fields are complete.</Typography>
            </>
          )}
        />
      )}
    </>
  )
}
